import { render, staticRenderFns } from "./OpportunityDrawer.vue?vue&type=template&id=24427f2e&"
import script from "./OpportunityDrawer.vue?vue&type=script&lang=js&"
export * from "./OpportunityDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports